'use client';
import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components';
import { SvgArrowMore } from '@/components/icons';
import { API_STATIC_FILES } from '@/utils/constants';
import { dateForFrontend } from '@/utils/dates';
import { device } from '@/constants/mediaQuery';
import s from './CardWithTitle.module.scss';

interface Props {
  image?: string | null;
  imageAlt?: string;
  href: string;
  date: string;
  title?: string | null;
}

export const CardWithTitle = (props: Props) => {
  const { href, date, title, image, imageAlt } = props;
  const photoUrl = `${API_STATIC_FILES}${image}`;

  return (
    <li>
      <Link className={s.card} href={href}>
        <div className={s.card__imageWrapper}>
          <span className={s.card__date} onClick={e => e.preventDefault()}>
            {dateForFrontend(date)}
          </span>
          <Image
            src={photoUrl}
            alt={imageAlt || 'Изображение на карточке'}
            sizes={`${device.mobile} 340px, ${device.laptop} 352px, 403px`}
            fill
          />
        </div>
        <div className={s.card__inner}>
          <p className={s.card__title} onClick={e => e.preventDefault()}>
            {title}
          </p>
          <Button
            name="Подробнее"
            type="button"
            theme="outline"
            size="block"
            rightIcon={<SvgArrowMore />}
          />
        </div>
      </Link>
    </li>
  );
};